import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import format from 'date-fns/format';
import { DSTheme } from '../../styles/themes/types';
import TableRow from '../Table/TableRow/TableRow';
import ProjectLogo from './ProjectLogo';
import ProjectStatus from './ProjectStatus';
import { ApplicationManagerInterface } from '../../interfaces/application';

const useStyles = makeStyles((theme: DSTheme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 1fr)',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
    gap: '10px',
    paddingBottom: '16px',

    [theme.breakpoints.up('md')]: {
      height: '104px',
      gridTemplateColumns: '0.5fr 1fr 1fr 1fr 0.5fr',
      gap: '0',
      paddingBottom: '0',
    },
  },
  tableRowContent: {
    width: '100%',
    height: '100%',
    boxShadow: 'inset 0px -1px 0px #808191;',
  },
  projectName: {
    fontWeight: 700,
  },
  companyName: {
    color: theme.palette.grey[700],
    marginTop: '8px',
  },
}));

type ProjectTableRowProps = {
  project: ApplicationManagerInterface;
  onClick: (projectId: string) => void;
};

const ProjectTableRow: React.FC<ProjectTableRowProps> = ({ project, onClick }) => {
  const classes = useStyles();
  const { application, organisation } = project;

  const formattedDate = format(new Date(application.lastUpdated as string), 'dd MMMM yyyy, HH:mm');

  return (
    <TableRow>
      <div
        role="row"
        className={classes.root}
        onClick={() => onClick(application.info.applicationId as string)}
      >
        <ProjectLogo
          src={application.assets?.appLogoUrl?.contentUrl}
          alt={application.info.name}
          height="54"
          width="54"
        />

        <div>
          <Typography variant="body1" className={classes.projectName}>
            {application.info.name}
          </Typography>

          <Typography variant="body2" className={classes.companyName}>
            {organisation.name}
          </Typography>
        </div>

        <Typography variant="body2">{application.info.applicationId}</Typography>
        <Typography variant="body2">{formattedDate}</Typography>

        <ProjectStatus status={application.setup.status} />
      </div>
    </TableRow>
  );
};

export default ProjectTableRow;
